import axios from 'axios';
import Cookies from 'js-cookie';

const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
  baseURL: `${REACT_APP_API_URL}/api/v1`,
  withCredentials: true,
});

function getToken() {
  return localStorage.getItem('accessToken') || Cookies.get('accessToken');
}

function setToken(token: string) {
  localStorage.setItem('accessToken', token);
  Cookies.set('accessToken', token);
}

function removeToken() {
  localStorage.removeItem('accessToken');
  Cookies.remove('accessToken');
}

axiosInstance.interceptors.request.use(
  async (config) => {
    const token = getToken();
    if (config.headers && token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log('Добавлен токен:', token.substring(0, 20) + '...'); // для отладки
    } else {
      console.log('Токен не найден');
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => {
    return Promise.resolve(response);
  },
  (error) => {
    if (error.response?.status === 401) {
      // TODO update token
      removeToken();
      // window.location.href = '/';
    }

    return Promise.reject(error);
  }
);

function instance(authorization = true, url?: string) {
  return axiosInstance;
}

export { setToken, getToken, removeToken };
export default instance;
